"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleHorizontalBarChart = void 0;
const react_1 = __importDefault(require("react"));
const SimpleHorizontalBarChart = ({ size, color }) => {
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 50 50", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M11 39.1875V11", stroke: color || '#2EB3B4', strokeWidth: "2.5625", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M11 13.5625H31.5V21.25", stroke: color || '#2EB3B4', strokeWidth: "2.5625", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M39.1875 21.25H11V28.9375H39.1875V21.25Z", stroke: color || '#2EB3B4', strokeWidth: "2.5625", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M26.375 28.9375V36.625H11", stroke: color || '#2EB3B4', strokeWidth: "2.5625", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.SimpleHorizontalBarChart = SimpleHorizontalBarChart;
